import React, { Component } from 'react'
import { Card, Button, Table, Modal, message } from 'antd'
import { PlusOutlined, EditOutlined, ApartmentOutlined, ArrowRightOutlined } from '@ant-design/icons';

import LinkButton from '../../components/link-button/index'

import { connect } from 'react-redux'
import { req_list_category, req_edit_category, req_add_category } from '../../api'

import CategoryAdd from './category-add'
import CategoryEdit from './category-edit'

import './category.less'

class Category extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    

    state = {
        loading: false,
        rows: [],
        sub_rows: [],
        nidParentCategory: 0,
        parentName: '',
        showModalStatus: 'HIDE' // MODEL HIDE:都不顯示；ADD:顯示添加；EDIT:顯示編輯 
    }

    /*
      第一次render()準備數據
    */
    UNSAFE_componentWillMount() {
        //console.log('UNSAFE_componentWillMount')
        this.init_columns()

    }

    /*
     執行ajax請求
    */
    componentDidMount() {
        //console.log('componentDidMount')
        this.api_list_rows()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    /* nidParentCategory 如果沒有指定，根據state中的nidParentCategory進行請求*/
    api_list_rows = async (nidParentCategory) => {
        const token = this.props.user.token

        this.setState({ loading: true })
        nidParentCategory = nidParentCategory || this.state.nidParentCategory
        const result = await req_list_category(nidParentCategory, token)
        this.setState({ loading: false })

        //console.log(result)
        if (result.total > 0) {
            const rows = result.data.reduce((row_pre, row) => {
                row_pre.push({ nidParentCategory: row.nidParentCategory, uid: row.uid, nidCategory: row.nidCategory, categoryName: row.categoryName })
                return row_pre
            }, [])
            if (nidParentCategory === 0) {
                this.setState({ rows })
            } else {
                this.setState({ sub_rows: rows })
            }
        }
    }

    api_edit_row = async (row) => {
        const token = this.props.user.token
        //console.log(row)
        const result = await req_edit_category(row, token)
        if (result.status === 'success') {
            // 1 結果提示
            message.success('編輯成功')
            this.setState({ showModalStatus: 'HIDE' })
            // 2 更新列表
            this.api_list_rows()
        } else {
            console.log(result)
        }
    }

    api_add_row = async (row) => {
        const token = this.props.user.token
        //console.log(row)
        const result = await req_add_category(row, token)
        if (result.status === 'success') {
            // 1 結果提示
            message.success('新增成功')
            this.setState({ showModalStatus: 'HIDE' })
            // 2 更新列表
            if (row.nidParentCategory === this.state.nidParentCategory.toString()) {
                // 當同一個層級下再刷新畫面
                this.api_list_rows()
            } else if (row.nidParentCategory === '0') {
                // 若在二級分類下添加一級分類，重新獲取一級分類列表數據，但不返回顯示一級列表
                this.api_list_rows(0)
            }
        } else {
            console.log(result)
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '分類名稱',
                dataIndex: 'categoryName',
            },
            {
                title: '操作',
                width: 220,
                render: (row) => (
                    <span>
                        <Button size='small' icon={<EditOutlined />} primary='true' onClick={() => { this.handle_showModal_edit_row(row) }}>修   改</Button>
                        { this.state.nidParentCategory === 0 ? <Button size='small' icon={<ApartmentOutlined />} primary='true' onClick={() => { this.handle_showBase_list_subrows(row) }}>下層分類</Button> : null}
                    </span>
                )
            }
        ]
    }

    // 操作互動處理 //////////////////////////////////////////////

    handle_cancel = () => {
        this.setState({ showModalStatus: 'HIDE' })
    }

    handle_showBase_list_subrows = (row) => {
        const { nidCategory, categoryName } = row
        //console.log(row)
        this.setState({
            nidParentCategory: nidCategory,
            parentName: categoryName
        }, () => {
            // 狀態更新且重新render後，執行函式
            // console.log(this.state.nidParentCategory)

            this.api_list_rows()


        })
    }

    handle_showBase_list_rows = () => {
        this.setState({
            nidParentCategory: 0,
            parentName: '',
            sub_rows: []
        })
    }

    handle_showModal_add_row = () => {
        this.setState({ showModalStatus: 'ADD' })
    }

    handle_process_add_row = () => {
        this.form_add_modal.current.validateFields().then(values => {
            const { nidParentCategory, categoryName } = values
            // console.log(values)
            this.api_add_row({ nidParentCategory: nidParentCategory, categoryName: categoryName })
        }).catch(error => {
            console.log(error.errorFields);
        });
    }

    handle_showModal_edit_row = (row) => {
        // console.log(row)
        this.row_edit = row;
        this.setState({ showModalStatus: 'EDIT' })

    }

    handle_process_edit_row = () => {
        this.form_edit_modal.current.validateFields().then(values => {
            const { uid, nidCategory } = this.row_edit
            const { categoryName } = values
            // console.log(values)
            this.api_edit_row({ condition: 'BASE', uid: uid, nidCategory: nidCategory, categoryName: categoryName })
        }).catch(error => {
            console.log(error.errorFields);
        });
    }

    ////////////////////////////////////////////////////////////

    render() {
        const { rows, sub_rows, loading, nidParentCategory, parentName, showModalStatus } = this.state
        const { categoryName } = this.row_edit || {}

        const title = nidParentCategory === 0 ? '主分類項目' : (
            <span>
                <LinkButton onClick={this.handle_showBase_list_rows}>主分類項目</LinkButton>
                <ArrowRightOutlined style={{ marginRight: 5 }} />
                <span>{parentName}</span>
            </span>);
        const extra = (<Button type='primary' icon={<PlusOutlined />} onClick={this.handle_showModal_add_row}>增加</Button>)

        return (
            <Card title={title} extra={extra} >
                <Table
                    bordered
                    loading={loading}
                    rowKey='uid'
                    dataSource={nidParentCategory === 0 ? rows : sub_rows}
                    columns={this.columns}
                    pagination={{ defaultPageSize: 5, showQuickJumper: true }}
                />

                <Modal
                    destroyOnClose={true}
                    title="增加分類"
                    visible={showModalStatus === 'ADD'}
                    onOk={this.handle_process_add_row}
                    onCancel={this.handle_cancel}
                >
                    <CategoryAdd categorys={rows} nidParentCategory={nidParentCategory.toString()} modalform={(form) => { this.form_add_modal = form }} />
                </Modal>

                <Modal
                    destroyOnClose={true}
                    title="更新分類"
                    visible={showModalStatus === 'EDIT'}
                    onOk={this.handle_process_edit_row}
                    onCancel={this.handle_cancel}
                >
                    <CategoryEdit categoryName={categoryName} modalform={(form) => { this.form_edit_modal = form }} />
                </Modal>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(Category)